import { Injectable } from '@angular/core';
import { ApiService } from '../../common/api.service';
import { Observable } from 'rxjs';
import { ROUTES } from '../../server-route';

@Injectable({
  providedIn: 'root'
})
export class ResetReviewService extends ApiService{
  public resetMemdata(memKey: string,payLoad: any): Observable<any> {
    return this.patch<any>(
      this.replacePathInfo(ROUTES.REVIEW_RESET,{
        memKey: memKey
      }),
      {
        body: payLoad,
      }
    );
  }
}
